import React from 'react'

import './graph-rounds.scss'
import { toFullTime } from 'lib/utilities'

interface CustomXAxisProps {
  displayFirstTick: boolean
  xAxisTicks: number[]
  roundComplete?: boolean
}

const CustomXAxis: React.FC<CustomXAxisProps> = ({ displayFirstTick, xAxisTicks, roundComplete }) => {
  return (
    <div
      className={`roundsGraph__x-axis__wrapper ${roundComplete ? 'roundsGraph__x-axis__wrapper--roundComplete' : ''}`}
    >
      <hr className="roundsGraph__x-axis__line" />
      <div style={{ position: 'relative' }}>
        <div className="roundsGraph__x-axis__ticksWrapper">
          {xAxisTicks.map((tick: number, tickIndex) => {
            return !displayFirstTick && tickIndex === 0 ? (
              <p key={tickIndex} />
            ) : (
              <p key={tickIndex}>{toFullTime(Math.round(tick)).slice(3)}</p>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default CustomXAxis
